<script>
import { fandomBasicMixin, fandomExtendedMixin } from 'src/modules/fandom_mixins_module.js';
import { vodafoneLabBasicMixin } from "../../modules/vodafone_lab_mixins_module.js";
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";
import { interactionMixin } from "src/modules/interactions_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin, vodafoneLabBasicMixin, interactionMixin],
  data: function () {
    return {
      nuanceText: null
    };
  },
  mounted() {
    Vue.nextTick(() => {
      const interval = setInterval(() => {
        let nuanceEl = document.getElementById("Nuance-chat-anchored");
        if (!!nuanceEl) {
          try {
            Vue.set(this, 'nuanceText', nuanceEl.getElementsByTagName('button')[0].innerText);
          } catch (error) { /* Nothing to do for now */ }
          clearInterval(interval);
        }
      }, 100);
    })
  },
  methods: {
    mayOpenChatUrl(event) {
      const href = $(event.currentTarget).attr("href");
      if (href == '#') {
        const nuanceEl = document.getElementById("Nuance-chat-anchored").getElementsByTagName('button')[0].click();
        sendFandomAnalyticsEvent("Interaction", "New-Chat-Clic", this.content.name);
        VodafoneLab.addDigitalDataEvent("chat-start", "tools", ":Chat open");
        nuanceEl.click(); 
      } else {
        window.location.href = href;
      }
      return false;
    }
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 7);
      return [
        `col-lg-${columnWidth}`
      ];
    },
  }
};
</script>

<template>
  <div 
    stripe-customer-care-component
    :class="contentType" 
    v-easyadmin="easyadminId" 
    class="position-relative"
    v-if="isContentVisibleToUser()" 
  >
    <div class="container d-flex align-items-center justify-content-center">
      <div class="row justify-content-center w-100">
        <div class="col-12 col-xl-10 py-5 px-0">
          <div v-if="content.actions"  class="row justify-content-center">
            <div v-if="content.title" class="h3 mb-0 col-12 col-md-4 pb-3 pb-md-0 d-flex align-items-center justify-content-center">{{content.title}}</div>
            <div v-for="(action, index) in content.actions" :key="`action-${index}`" class="contact-item col-12 col-md-3 pb-2 pb-md-0">                
              <a :href="action.url.url == '$nuance' ? '#' : action.url.url" @click.prevent="mayOpenChatUrl($event)" :target="getTarget(action.url)" class="cursor-pointer px-4 py-3 py-md-4 h-100 w-100 d-flex flex-md-column tile-shadow align-items-center">
                  <template v-if="action.description">
                  <img :src="action.icon.url" v-if="action.icon" class="icon mt-md-4"/>
                  <div v-html="(action.url.url == '$nuance' && nuanceText) ? nuanceText : action.description"></div>
                </template>


                <template v-else>
                  <img :src="action.icon.url" v-if="action.icon" class="icon mt-md-4"/>
                  <div class="box-title font-weight-bold ml-4 ml-md-0 mb-0 mt-md-4 mb-md-4">
                    {{(action.url.url == '$nuance' && nuanceText) ? nuanceText : (action.url.title || action.url.url)}}
                  </div>
                </template>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[stripe-customer-care-component] {

  #Nuance-chat-anchored {
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    margin-left: 0;
    line-height: 1.5rem;

    .icon {
      display: none;
    }

    .button {
      font-weight: bold;
      font-size: 1.25rem;
    }

    @include media-breakpoint-down(md) {
      margin-left: 1.5rem;
      margin-top: 0;
      margin-bottom: 0;
    }
  }

  .contact-item {
    & > a {
      border-radius: 6px;
      transition: all .25s;
      background-color: $white;
      border-radius: 6px;
      text-align: center;
      color: $black;

      .icon {
        height: 5rem;
        width: auto;
        transition: filter .25s;
        @include media-breakpoint-down(sm) {
          height: 3rem;
        }
      }

      .box-title {
        font-size: 1.25rem;
      }

      @include hover {
        color: $primary;
        box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.32);
      }

      p {
        margin-bottom: 0;
      }
    }
  }
}
</style>
